import request, { METHODS } from '@/api'
import { fastFunctionMenuSettingAddOrDel } from '@/services/homeService'
import { dfs } from '@/utils/common'
import { DownOutlined } from '@ant-design/icons'
import { Col, Row, Spin, Tree, message } from 'antd'
import { cloneDeep } from 'lodash-es'
import React, { Children, useEffect, useState } from 'react'
import { useFileUrlPrefix } from 'shj-utils'
import styles from '../../../index.module.less'

const favoritesList = (props: any) => {
  const [treeData, setTreeData] = useState<Array>([])
  const [expandedKeys, setExpandedKeys] = useState<React.Key[]>([])
  const [selectedKeys, setSelectedKeys] = useState<React.Key[]>([])
  const [shortcutList, setShortcutList] = useState<Array>([]) // 快捷功能
  const [imagePrefix] = useFileUrlPrefix()
  const { shortcutIds, menuIds, reload } = props
  const [loading, setLoading] = useState(false)

  const [favoriteList, setFavoriteList] = useState<Array>([])

  useEffect(() => {
    getCurrentResourcesList()
  }, [])

  /**
   * 根据树子节点ID查找所有父节点ID
   * @param {array} dataSource 树形结构数据源
   * @param {number|string} id 子节点ID
   * @returns {array} 包含所有父节点ID的数组，按照从根节点到直接父节点的顺序排序
   */
  const findParentIds = (dataSource, nid) => {
    const parentIds = [] // 用于存储所有父节点ID的数组
    // 定义一个递归函数，用于遍历整棵树并查找子节点的所有父节点
    const traverse = (node, nid) => {
      if (node.nid === nid) {
        // 如果当前节点的ID等于子节点的ID，则表示已经找到了子节点，可以开始向上查找父节点
        parentIds.unshift(node.nid)
        return true // 返回true表示已经找到了子节点
      }
      if (node.children) {
        // 如果当前节点有子节点，则继续遍历子节点
        for (const childNode of node.children) {
          if (traverse(childNode, nid)) {
            // 如果在子节点中找到了子节点的父节点，则将当前节点的ID添加到父节点ID数组中，并返回true表示已经找到了子节点
            parentIds.unshift(node.nid)
            return true
          }
        }
      }
      return false // 如果当前节点不是子节点的父节点，则返回false
    }
    // 从根节点开始遍历整棵树，并调用递归函数查找子节点的所有父节点
    for (const node of dataSource) {
      if (traverse(node, nid)) {
        // 如果在当前节点的子树中找到了子节点的父节点，则直接退出循环
        break
      }
    }
    return parentIds // 返回所有父节点ID的数组
  }

  const getCurrentResourcesList = () => {
    setLoading(true)
    // request(`/caas-web/resources/current`, {
    //   method: METHODS.POST,
    // })
    request(`/caas-web/controlPanel/currentResources`, {
      method: METHODS.GET,
    })
      .then((resp: any) => {
        setLoading(false)
        const { menu, shortcut } = resp
        let data = resp.menu
        let list = []
        let arr = []
        dfs(data, (item: any, index: any) => {
          item.title = item.name
          item.key = item.nid
          menuIds.map((eve, i) => {
            if (eve.id === item.nid) {
              arr.push(eve.id)
              item.favoriteCheck = true
              const ids = findParentIds(data, item.nid)
              list.push(...ids)
            }
          })
        })
        shortcutIds.map((item, index) => {
          shortcut.map((eve, i) => {
            if (item.id === eve.id) {
              arr.push(eve.id)
              eve.favoriteCheck = true
            }
          })
        })
        setFavoriteList(arr)
        setShortcutList(shortcut)
        setTreeData(data)
        setExpandedKeys(list)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const favoriteFn = (record: any, check: boolean) => {
    let list = cloneDeep(shortcutList)
    list.map((item, index) => {
      if (item.id === record.id) {
        item.favoriteCheck = check
      }
    })
    setShortcutList(list)
    fastFunctionMenuSettingAddOrDel(record.id, record.type)
  }

  const onExpand = (expandedKeysValue: React.Key[]) => {
    setExpandedKeys(expandedKeysValue)
  }

  const onSelect = (selectedKeysValue: React.Key[], info: any) => {
    const record = info.node
    if (record.children) return
    let arr = cloneDeep(favoriteList)
    if (!record.favoriteCheck) {
      if (arr.length > 7) {
        return message.warning('当前收藏数已达到上限，请先取消其他收藏，再收藏该功能')
      } else {
        arr.push(record.nid)
      }
    } else {
      var index = arr.indexOf(record.nid)
      if (index > -1) {
        arr.splice(index, 1)
      }
    }
    let list = cloneDeep(treeData)
    dfs(list, (item: any) => {
      if (!item.children || !item.children.length) {
        if (item.nid === record.nid) {
          item.favoriteCheck = !record.favoriteCheck
        }
      }
    })
    setFavoriteList(arr)
    fastFunctionMenuSettingAddOrDel(record.nid, record.type)
    setTreeData(list)
  }

  return (
    <Spin spinning={loading}>
      <div>
        <div className={styles.favoriteTitle}>按照收藏的先后顺序展示</div>
        <div>
          <div className={styles.shortcutTitle}>快捷功能</div>
          <Row>
            {shortcutList.map((item, index) => {
              return (
                <Col
                  span={4}
                  className={styles.iconContet}
                  key={index}
                  onClick={e => {
                    e.stopPropagation()
                    if (item.key === 'shortcut1') {
                      // 新建线索
                      setAddRefRecord({})
                    } else if (item.key === 'shortcut2') {
                      // 新建员工
                      setIsVisible(true)
                      setState({ editVisible: true, editTitle: '新增' })
                    } else if (item.key === 'shortcut3') {
                      // 新建问题
                      // setState1({
                      //   issueId: '',
                      //   addOpen: true,
                      //   isEdited: false,
                      // })
                    }
                  }}
                >
                  <div className={styles.iconBox}>
                    {item.icon ? (
                      <img src={imagePrefix + item.icon} className={styles.imgIcon} />
                    ) : (
                      ''
                    )}
                  </div>
                  <div className={styles.iconText}>{item.name}</div>
                  <div className={styles.favoriteIcon}>
                    <img
                      src={
                        item.favoriteCheck
                          ? require('@/assets/favoriteCheck.png')
                          : require('@/assets/favorite.png')
                      }
                      onClick={e => {
                        e.stopPropagation()
                        favoriteFn(item, !item.favoriteCheck)
                      }}
                      alt="back"
                      style={{ width: '12px', height: '12px' }}
                    />
                  </div>
                </Col>
              )
            })}
          </Row>
        </div>
        <div>
          <div className={styles.shortcutTitle}>菜单列表</div>
          <div>
            <Tree
              showLine
              // fieldNames={{ label: 'name', value: 'nid', children: 'children' }}
              switcherIcon={<DownOutlined />}
              onExpand={onExpand}
              expandedKeys={expandedKeys}
              onSelect={onSelect}
              treeData={treeData}
              titleRender={(nodeData: any) => {
                if (!nodeData.children) {
                  return (
                    <div key={nodeData.nid}>
                      <span>
                        <span>{nodeData.title}</span>
                        <img
                          src={
                            nodeData.favoriteCheck
                              ? require('@/assets/favoriteCheck.png')
                              : require('@/assets/favorite.png')
                          }
                          alt="back"
                          style={{ width: '12px', height: '12px', marginLeft: '20px' }}
                        />
                      </span>
                    </div>
                  )
                } else {
                  return <span>{nodeData.title}</span>
                }
              }}
            />
          </div>
        </div>
      </div>
    </Spin>
  )
}
export default favoritesList
